module.exports = __webpack_public_path__ + "img/arrow_forward_black.bdcdb2d5.svg";